import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { MoreVert } from '@mui/icons-material';
import EditEpisodeDialog from './Dialogs/EditEpisodeDialog';
import DeleteEpisodeDialog from './Dialogs/DeleteEpisodeDialog';
import { EpisodeData } from './types';

export default function EpisodeMoreActions({ episode }: { episode: EpisodeData }) {
    const [editOpen, setEditOpen] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleOpen = (dispatch: React.Dispatch<React.SetStateAction<boolean>>) => () => {
        handleClose();
        dispatch(true);
    }

    return (
        <>
            <IconButton sx={{ mh: 40 }} onClick={handleClick}>
                <MoreVert />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <MenuItem onClick={handleOpen(setEditOpen)}>Edit</MenuItem>
                <MenuItem onClick={handleOpen(setDeleteOpen)}>Delete</MenuItem>
            </Menu>
            <EditEpisodeDialog episode={episode} open={editOpen} onClose={() => setEditOpen(false)} />
            <DeleteEpisodeDialog episode={episode} open={deleteOpen} onClose={() => setDeleteOpen(false)} />
        </>
    )
}